/**
 * NP-45 — borrower settings (theme preference persistence on the account record).
 *
 * Backend contract (already in the OpenAPI spec / api.gen.ts):
 *   GET   /api/v1/borrower/me/settings  → { notificationPreferences, theme }
 *   PATCH /api/v1/borrower/me/settings  ← { theme }  → { theme }
 *
 * Only the theme slice is used here; notification preferences continue to be
 * managed via their own endpoint in the Settings page.
 */
import { apiClient } from "./api-client";
import { normalizeTheme, type Theme } from "@/lib/theme";

export const settingsService = {
  /** The theme persisted on the account, or null if unset/unavailable. */
  async getTheme(): Promise<Theme | null> {
    try {
      const res = await apiClient.get<{ theme?: string | null }>(
        "/api/v1/borrower/me/settings",
        { suppressToast: true },
      );
      return normalizeTheme(res?.theme);
    } catch {
      // Endpoint unavailable / unauthenticated — fall back to local persistence.
      return null;
    }
  },

  /** Persist the chosen theme to the account record. */
  async updateTheme(theme: Theme): Promise<void> {
    await apiClient.patch(
      "/api/v1/borrower/me/settings",
      { theme },
      { suppressToast: true },
    );
  },
};
